import React from 'react';
import { useAppDispatch, useAppSelector, useDisplayCarteira, useCheckAllLoaded, setIsLoadingMinimized, cancelarAPI, setData, setDataFim } from '@monorepo-web/logic-extrato';
import {Header, IHeader, DataFim, Instituicao, Benchmarks} from '@monorepo-web/components-library';

import PeriodoWrapper from '../PeriodoWrapper';

type HeaderProps = Omit<IHeader, 'checkAllLoaded' | 'handleTrocarCarteira' | 'BenchComponent' | 'InstComponent' | 'PeriodoComponent'> & {
    periodo?: boolean;
    dataFim?: boolean;
    benchmarks?: {
        selectedBenchmarks: string[] | null;
        dispatchSelectedBenchmarks: (newBenchmarks: string[]) => any;
        customItemOptions: { value: string; label: string }[];
    };
    instProps?: {
        options: string[];
        initialOption: string;
        loadingOptions: boolean;
        handleSelect: (value: string) => void;
    };
};

export default function HeaderWrapper(props: HeaderProps) {
    const [
        dataInicialCarteira,
        dataFinalCarteira,
        periodo,
        carteiraSelecionada,
        carteiraList,
        isLoadingMinimized,
    ] = useAppSelector((state) => [
        state.preference.dateStart,
        state.preference.dateEnd,
        state.preference.params.periodo,
        state.preference.params.carteira,
        state.preference.carteiraList,
        state.loadMinimized.isLoadingMinimized,
    ]);
    const dispatch = useAppDispatch();

    const checkAllLoaded = useCheckAllLoaded();
    const displayCarteira = useDisplayCarteira(carteiraList, carteiraSelecionada);

    /**
     * Caso o modal de loading esteja minimizado, cancelar as chamadas da API
     * ao navegar para a página de selecionar carteira
    */
    const handleClickTrocarCarteira = () => {
        if (isLoadingMinimized) {
            cancelarAPI();
            setIsLoadingMinimized(false);
        }
    };

    const onChangePeriodo = (value: any) => {
        dispatch(setData(value));
    };
    const onAcceptDataFim = (dataFinal: string) => {
        dispatch(setDataFim(dataFinal))
    };

    const PeriodoComponent = ( props.periodo ?
        <PeriodoWrapper
            periodo={periodo}
            obj_datas={props.obj_datas}
            disabled={isLoadingMinimized}
            onChange={onChangePeriodo}
        />
        : (props.dataFim ?
            <DataFim
                obj_datas={props.obj_datas}
                dataInicialCarteira={dataInicialCarteira}
                dataFinalCarteira={dataFinalCarteira}
                disabled={isLoadingMinimized}
                onAccept={onAcceptDataFim}
            /> : null));

    const InstComponent = props.instProps ? (
        <Instituicao
            options={props.instProps?.options}
            initialOption={props.instProps?.initialOption}
            loadingOptions={props.instProps?.loadingOptions}
            disabled={isLoadingMinimized}
            handleSelect={props.instProps?.handleSelect}
        />) : null;

    const BenchComponent = props.benchmarks ? (
        <Benchmarks
            selectedBenchmarks={props.benchmarks.selectedBenchmarks}
            dispatchSelectedBenchmarks={props.benchmarks.dispatchSelectedBenchmarks}
            customItemOptions={props.benchmarks.customItemOptions}
            disabled={isLoadingMinimized}
        />) : null;

    return (
        <Header
            {...props}
            checkAllLoaded={checkAllLoaded}
            handleTrocarCarteira={handleClickTrocarCarteira}
            displayCarteira={displayCarteira}
            PeriodoComponent={PeriodoComponent}
            InstComponent={InstComponent}
            BenchComponent={BenchComponent}
            unicaCarteira={carteiraList.length === 1}
        />
    );
}
